import { isGrabIDAuthenticated } from 'helper/grab-id-auth-helper';
import _last from 'lodash/last';
import _get from 'lodash/get';
import { ROUTES_V2_PATHS } from 'constants/route-constants';
import {
  verifyGFBSession,
  isAuthHintLocal,
  isAuthHintCookie,
  clearLoginStorage,
} from './session-helper';

/**
 * (AUTH_HINT_COOKIE) New GFB Migrated Flow uses Cookie
 * (AUTH_HINT_LOCAL) Existing GFB Flow uses Token
 * bypassAuthHintCheck is true for first Log in, where there is no Authhint.
 * We need to do server-side authentication check for https-secure cookie -- it is not advisible to access locally and validate locally
 */
export const isUserAuthenticatedAsync = async (bypassAuthHintCheck = false) => {
  if (isAuthHintLocal()) {
    return isGrabIDAuthenticated();
  }
  if (!isAuthHintCookie() && !bypassAuthHintCheck) {
    clearLoginStorage();
    return false;
  }

  return verifyGFBSession()
    .then(session => {
      if (session.user) {
        return true;
      }
      clearLoginStorage();
      return false;
    })
    .catch(_ => {
      clearLoginStorage();
      return false;
    });
};

export const isLoginPage = () => {
  const pathname = `/${_last(window.location.pathname.split('/'))}`;
  return pathname === ROUTES_V2_PATHS.login;
};

export const getLogoutTargetUrl = () =>
  _get(window, 'Grab.config.endpoints.expressHomeBaseUri') ||
  _get(window, 'Grab.config.uri');

export default {};
